import React, { memo, useContext } from 'react'
import {
  Box,
  ResponsiveBox,
} from '@usap/uicomponents'
import seoIDs from '../../../config/seoIds'
import { SearchContext } from '../common/context/SearchContextProvider'
import SortBy from './SortBy'
import UniversalCheckbox from './UniversalCheckbox'
import DisplayItemsComponent from './DisplayItemsComponent'
import FilterResultLabel from './topBarFilterComponents/FilterResultLabel'
import TopBarHeadingContainer from './topBarFilterComponents/TopBarHeadingContainer'

const TopBarFilterOptions = props => {
  const {
    toggleItemsPerPage = () => {},
  } = props

  const {
    searchState: { products },
  } = useContext(SearchContext)
  const { resultCount: numberOfProducts = 0 } = products
  const hasMoreThan15 = Boolean(numberOfProducts > 15)

  return (
    <Box
      id="topBarFilter"
      border={{
        side: 'bottom',
        color: 'light-3',
        size: 'xsmall',
      }}
      pad={{ bottom: 'small' }}
      margin={{ bottom: 'small' }}
    >
      <TopBarHeadingContainer />

      <FilterResultLabel />

      <ResponsiveBox
        id="topBarFilterSection"
        justify="between"
        direction="row"
        fxIf={{ large: true, other: false }}
      >
        <Box
          id={`${seoIDs.directFitCheckBox}Wrapper`}
          alignSelf="center"
          width="33%"
        >
          <UniversalCheckbox toggleItemsPerPage={toggleItemsPerPage} />
        </Box>

        <ResponsiveBox
          id="showItemsBarWrapper"
          width="33%"
          fxIf={{ large: hasMoreThan15 }}
        >
          <DisplayItemsComponent
            toggleItemsPerPage={toggleItemsPerPage}
          />
        </ResponsiveBox>

        <Box id={`${seoIDs.sortByFilter}Wrapper`} width="33%" justify="end">
          <SortBy
            toggleItemsPerPage={toggleItemsPerPage}
          />
        </Box>
      </ResponsiveBox>
    </Box>
  )
}
export default memo(TopBarFilterOptions)
